<script setup lang="ts">
import { User, UserInitiative } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});

const store = useStore<ShiftCMSState & { us: UsersState }>();

const initiatives = computed<UserInitiative[]>(
  () => store.state.us.userInitiatives,
);

const headers = [
  { title: 'Initiative', key: 'initiative.title' },
  { title: 'Status', key: 'completed' },
  { title: 'Completed Steps', key: 'steps' },
  { title: 'Options', key: 'options' },
];

function deleteUserInitiative(id: number) {
  store.dispatch(UsersActions.DeleteUserInitiative, {
    id,
    userId: props.user.id,
  });
}
</script>
<template>
  <v-card class="mt-4">
    <v-card-title>Initiatives</v-card-title>

    <v-data-table
      density="compact"
      :headers="headers"
      :items="initiatives"
      itemsPerPage="10"
      hover
    >
      <template v-slot:item.completed="{ value }">
        {{ value ? 'Completed' : 'Open' }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn
          density="compact"
          icon="mdi-delete-outline"
          @click="deleteUserInitiative(item.id)"
        /> </template
    ></v-data-table>
  </v-card>
</template>
